import { APIPaths } from '@/common/constants';

interface ContactSalesFormData {
  recipient: string;
  name: string;
  company_name: string;
  message: string;
  is_early_signup: boolean;
}

interface ContactSalesResponse {
  success: boolean;
  message: string;
}

export const sendContactSalesEmail = async (
  formData: ContactSalesFormData
): Promise<ContactSalesResponse> => {
  try {
    const url = `${process.env.REACT_APP_BASE_URL}api${APIPaths.contact_sales}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      const result = await response.json();
      throw new Error(result.error || 'Failed to send your message.');
    }

    return {
      success: true,
      message: 'Your message has been sent successfully!',
    };
  } catch (error) {
    console.error('Error:', error);
    return {
      success: false,
      message:
        error instanceof Error
          ? error.message
          : 'An error occurred while sending your message.',
    };
  }
};
